import * as types from "../actions/actionTypes"
import initialState from "./initialState";

export default function navItemsReducer(state = initialState.navItems, action) {
    if (action.type === types.NAVITEMS_SET) {
        return action.navItems; 
    } 

    return state;
}



// WEBPACK FOOTER //
// ./src/redux/reducers/navItemsReducer.js